import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { useEffect, useRef } from 'react';
import { useControl } from 'react-map-gl';

export default function DrawControl(props) {
  const mapDraw = useRef(null); // <- initialize a ref

  useControl(
    () => {
      const draw = new MapboxDraw(props); // <- Store instance in a variable
      mapDraw.current = draw; // <- Assign it to ref

      return draw; // <- return instance
    },
    ({ map }) => {
      map.on('draw.create', props.onCreate);
      map.on('draw.update', props.onUpdate);
      map.on('draw.delete', props.onDelete);
    },
    ({ map }) => {
      map.off('draw.create', props.onCreate);
      map.off('draw.update', props.onUpdate);
      map.off('draw.delete', props.onDelete);
    },
    {
      position: props.position,
    },
  );

  useEffect(() => {
    // Draw the pre-loaded delivery areas
    if (mapDraw.current && props.initialFeatures) {
      mapDraw.current.deleteAll();
      props.initialFeatures.features.forEach((feature) => {
        mapDraw.current.add(feature);
        mapDraw.current.changeMode('draw_polygon');
      });
    }
  }, [props.initialFeatures]);

  return null;
}

DrawControl.defaultProps = {
  onCreate: () => {},
  onUpdate: () => {},
  onDelete: () => {},
};
